const defaultToken: string = 'no-csrf-token-found'

function authenticityToken(): string {
  const metaTag = document.querySelector('meta[name="csrf-token"]')

  if (metaTag) {
    return metaTag.getAttribute('content') || defaultToken
  } else {
    return defaultToken
  }
}

export function localFetch(url: string, init?: RequestInit) {
  init = init || {}
  const headers = init.headers
  delete(init.headers)

  return fetch(
    url,
    {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': authenticityToken(),
        ...headers,
      },
      credentials: 'same-origin',
      ...init,
    },
  )
}
